import apk from "./contrall-2.30(113)-release.apk";

export default apk;
